import ClinicMap from './modules/clinic-map';
import Services from './modules/services';
import Accordion from './modules/accordion';
import Slider from './modules/slider';
import Tabs from './modules/tabs';
import Menu from './modules/menu';
import Search from './modules/search';
import React from 'react';
import ReactRender from './tools/react-render';
import { initEm } from './init';

initEm();

new Menu();
new Search();
new ClinicMap();
new Services();
new Accordion();
new Slider();
new Tabs();

const destinationSearchEl = document.querySelector(
    '[data-behaviour="destination-search"]',
);
if (destinationSearchEl) {
    const Destinations = React.lazy(() => import('./components/Destinations'));
    ReactRender(<Destinations />, destinationSearchEl);
}
